document.addEventListener('DOMContentLoaded', function () {
    if (typeof TweenMax === 'undefined' || typeof TweenLite === 'undefined') {
      console.warn('GSAP (TweenMax/TweenLite) not found.');
      return;
    }

    // Create (or reuse) a fixed overlay so the effect never changes page height
    var container = document.getElementById('leafOverlay');
    if (!container) {
      container = document.createElement('div');
      container.id = 'leafOverlay';
      document.body.appendChild(container);
    }

    var total = 20;
    var w = window.innerWidth;
    var h = window.innerHeight;

    for (let i = 0; i < total; i++) {
      var Div = document.createElement('div');
      Div.className = 'dot';

      TweenLite.set(Div, { x: R(0, w), y: R(-200, -150), z: R(-200, 200) });
      container.appendChild(Div);
      animm(Div);
    }

    function animm(elm) {
      // fall vertically; read the latest height each cycle so resizing doesn’t push layout
      TweenMax.to(elm, R(6, 15), {
        y: function () { return h + 100; },
        ease: Linear.easeNone,
        repeat: -1,
        delay: -15
      });

      // gentle sway
      TweenMax.to(elm, R(4, 8), {
        x: '+=100',
        rotationZ: R(0, 180),
        repeat: -1,
        yoyo: true,
        ease: Sine.easeInOut
      });

      // subtle 3D spin (remove if you don’t want any thickness changes)
      TweenMax.to(elm, R(2, 8), {
        rotationX: R(0, 360),
        rotationY: R(0, 360),
        repeat: -1,
        yoyo: true,
        ease: Sine.easeInOut,
        delay: -5
      });
    }

    function R(min, max) { return min + Math.random() * (max - min); }

    window.addEventListener('resize', function () {
      w = window.innerWidth;
      h = window.innerHeight;
    });
  });